import styled, { css } from 'styled-components';
import watermark from '../../assets/images/watermark.svg';

export const Modal = styled.section`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
  z-index: 7;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 5%;
  }

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.gradient[180]};
    opacity: 0.5;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;

    transform: translateY(30%) translateX(20%);
    inset: 0;
    background-image: url(${watermark});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.2;
    pointer-events: none;
    z-index: -1;
  }
`;

export const Group = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 560px;
  padding: 48px 68px;
  background-color: ${({ theme }) => theme.colors.grey.black};
  border-radius: 16%;

  .close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 5%;
    right: 5%;
    padding: 12px;
    border-radius: 100%;
    background-color: rgba(256, 256, 256, 0.2);
    border: 0;

    svg {
      width: 24px;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 340px;
  height: min-content;
  display: flex;
  position: relative;

  @media ${({ theme }) => theme.devices.mobile} {
    width: calc(50% - 4px);
  }

  > div {
    width: 100%;
    max-width: 340px;
    min-height: 320px;
    max-height: 320px;
    border-radius: 28px;
    overflow: hidden;
    z-index: 0;
    border: 1px solid ${({ theme }) => theme.colors.grey[200]};

    @media ${({ theme }) => theme.devices.mobile} {
      min-height: 40px;
      max-height: 200px;
    }

    ${({ $modelIs2 }) =>
      $modelIs2 &&
      css`
        min-height: 380px;
        max-height: 380px;

        @media ${({ theme }) => theme.devices.mobile} {
          max-height: 280px;
        }
      `}

    ${({ $modelIs3 }) =>
      $modelIs3 &&
      css`
        min-height: 440px;
        max-height: 440px;

        @media ${({ theme }) => theme.devices.mobile} {
          min-height: 300px;
        }
      `}

    ${({ $bost }) =>
      $bost &&
      css`
        padding: 6px;
        border: 0;

        @media ${({ theme }) => theme.devices.mobile} {
          padding: 4px;
        }

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 25px;
          background: ${({ theme }) => theme.colors.gradient.fullX};
          opacity: 0.5;
          z-index: -2;
        }

        &::after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 25px;
          padding: 6px;
          background: ${({ theme }) => theme.colors.gradient.fullX};
          -webkit-mask: linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          z-index: 2;

          @media ${({ theme }) => theme.devices.mobile} {
            padding: 4px;
          }
        }
      `}
  }
`;

export const Banner = styled.div`
  width: 100%;
  height: 200px;
  border-radius: 20px 20px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.grey[800]};

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';

    background-image: url(${({ $banner }) => $banner});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    height: 120px;
  }
`;

export const GroupInfos = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 8px 4px;
  }
`;

export const GroupImgDescription = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  position: relative;
  top: -50px;

  @media ${({ theme }) => theme.devices.mobile} {
    top: -25px;
    width: 64px;
  }

  span {
    width: 100%;
    font-size: 12px;
    padding: 8px 0;
    margin-top: 8px;
    padding-left: 10px;
    border-left: 1px solid ${({ theme }) => theme.colors.grey.white};

    @media ${({ theme }) => theme.devices.mobile} {
      display: block;
      font-size: 8px;
      padding-left: 4px;
      border-left: 1px solid ${({ theme }) => theme.colors.grey.white}66;
    }
  }
`;

export const ImgDescription = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.grey[800]};

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';

    background-image: url(${({ $img }) => $img});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    width: 64px;
    height: 64px;
  }
`;

export const Infos = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }

  h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 340px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 14px;
    }
  }
`;

/* prettier-ignore-start */
export const GroupText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 340px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 11px;
      word-spacing: -1.7px;
    }
  }

  span {
    color: ${({ theme }) => theme.colors.grey[200]};
    margin-bottom: -4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 340px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 10px;
    }

    ${({ $bost }) =>
      $bost &&
      css`
        color: ${({ theme }) => theme.colors.grey.white};
      `}
  }

  .bottom {
    margin-bottom: -4px;
  }

  .location {
    margin-bottom: -4px;
    opacity: 0.5;
  }

  .width {
    max-width: 17px;
    height: 17px;
    /* background-color: red; */
    margin-bottom: -2px;
    margin-left: 1px;
    margin-right: 2px;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 11px;
    }
  }

  img {
    width: 100%;
    max-width: 20px;
    height: 20px;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 12px;
      height: 12px;
    }
  }
`;
/* prettier-ignore-end */

export const GroupButton = styled.div`
  width: 90%;
  border-radius: 24px;
  margin-bottom: 8px;
  background-color: red;
  position: absolute;
  bottom: 2%;
  left: 50%;
  transform: translate(-50%);

  @media ${({ theme }) => theme.devices.mobile} {
    width: 90%;
  }

  a {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 4px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};
    border: 0;
    border-radius: 24px;

    @media ${({ theme }) => theme.devices.mobile} {
      padding: 0;
      height: 32px;
    }

    svg {
      width: 28px;

      @media ${({ theme }) => theme.devices.mobile} {
        width: 16px;
      }

      path {
        stroke-width: 3px;
      }
    }

    h4 {
      font-size: 24px;
      font-weight: 500;
      /* font-family: 'Anton', sans-serif; */

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 16px;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[200]};
    }

    ${({ $bost }) =>
      $bost &&
      css`
        background: ${({ theme }) => theme.colors.gradient.fullX};
        color: ${({ theme }) => theme.colors.grey.white};

        &:hover {
          transition: 0.7s;
          opacity: 0.7;
        }
      `}
  }
`;

export const GroupPayment = styled.div`
  width: 100%;
  margin-top: 12px;
  text-align: center;

  div {
    margin-top: 12px;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    border-radius: 12px;
    margin-left: auto;

    small {
      img {
        width: 24px;
        height: 24px;
      }

      padding: 4px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      font-size: 12px;
      text-align: center;
      text-transform: uppercase;

      &:nth-child(2) {
        border-left: 1px solid ${({ theme }) => theme.colors.grey.white};
      }
    }
  }
`;

export const PaymentButton = styled.button`
  width: 100%;
  padding: 20px;
  display: flex;
  border: 0;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  &:hover {
    transition: 0.7s;
    opacity: 0.7;
  }

  h4 {
    font-size: 36px;
    margin-bottom: -4px;
    font-weight: 400;
    font-family: 'Bebas Neue', sans-serif;
  }
`;
